import React from "react";

export default function AgeMessage({minage, maxage, minagedate, maxagedate}) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("fa-IR", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    // حالت اول: سن
    if (minage || maxage) {
        if (minage && maxage) {
            return <span>برای سنین {minage} تا {maxage} سال</span>;
        } else if (minage) {
            return <span>برای سنین بالای {minage} سال</span>;
        } else if (maxage) {
            return <span>برای سنین زیر {maxage} سال</span>;
        }
    }

    // حالت دوم: تاریخ تولد
    if (minagedate || maxagedate) {
        if (minagedate && maxagedate) {
            return (
                <span>
          برای متولدین بین{" "}
                    {formatDate(minagedate)} تا {formatDate(maxagedate)}
        </span>
            );
        } else if (minagedate) {
            return (
                <span>
          برای متولدین بعد از {formatDate(minagedate)}
        </span>
            );
        } else if (maxagedate) {
            return (
                <span>
          برای متولدین قبل از {formatDate(maxagedate)}
        </span>
            );
        }
    }

    // حالت پیش‌فرض
    return <span>بدون محدودیت سنی</span>;
};
